const ModuleLiveTimer = {
  state: {
    timers: {}
  },
  mutations: {
    settimers (state, { dealId, time }) {
      // state.timers[dealId] = time
      this._vm.$set(state.timers, dealId, time)
    },
    cleartimer (state, { dealId }) {
      this._vm.$delete(state.timers, dealId)
    }
  },
  actions: {
    actionsSetTimer (context, access) {
      var Currentime = Date.now()
      access.forEach(item => {
        if (access.is_deal) {
          var diff = new Date(access.deal_detail[0].deal_enddate).getTime() - Currentime
          const hours = Math.floor(diff / (1000 * 60 * 60))
          const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
          const seconds = Math.floor((diff % (1000 * 60)) / 1000)
          var time = {
            time: `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`,
            dealId: access.deal_detail[0].deal_id
          }
          context.commit('settimers', time)
          var currentTime = this.$store.state.ModuleLiveTimer.timers
          access.time = currentTime[item.deal_detail[0].deal_id]
        }
      })
    }
  }
}

export default ModuleLiveTimer
